export default "__VITE_ASSET__BHa3fp9o__"